export default __webpack_public_path__ + "static/media/QHS_Logo2.c9634a3b.png";